module.exports = __webpack_public_path__ + "img/zizhi1.0046e7c4.jpg";